import gql from 'graphql-tag';

const exportEmotionalTriggersTableQuery = gql`
  query exportEmotionalTriggersTable($id: Int!, $fileExtension: String!, $thematicSelectionId: Int) {
    exportEmotionalTriggersTable(id: $id, fileExtension: $fileExtension, thematicSelectionId: $thematicSelectionId) {
      code
      message
    }
  }
`;

export default exportEmotionalTriggersTableQuery;
